import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

import styles from './HiddenGroup.module.scss'

const HiddenGroup = ({
    t,
    hiddenText = t('More options'),
    visibleText = t('Less options'),
    defaultIsVisible = false,
    children,
}) => {
    const [isVisible, setIsVisible] = useState(defaultIsVisible)

    return (
        <div className={styles.hiddenGroup}>
            <div
                className={classNames(styles.toggle, {
                    [styles.isVisibleToggle]: isVisible,
                })}
                onClick={() => setIsVisible(!isVisible)}
            >
                {isVisible ? visibleText : hiddenText}
            </div>
            {isVisible && <div className={styles.content}>{children}</div>}
        </div>
    )
}

export default withTranslation()(HiddenGroup)
